var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/upload/upload-file.ts
import Cookies from "js-cookie";
import { Auth } from "@leagueplatform/auth";

// src/utils/use-content-blob-url.hook.ts
import { useQuery } from "@tanstack/react-query";
import { getConfig } from "@leagueplatform/config";
import { leagueFetch } from "@leagueplatform/league-fetch";
import { useEffect } from "react";
var getContentUrlConfigValue = () => getConfig().config.core.contentUrl;
var getContentUrl = (contentId) => {
  console.warn(
    'Warning: "getContentUrl" is deprecated. Use the hook "useContentBlobUrl" instead.'
  );
  const contentPath = `content/${contentId}`;
  return contentId ? `${getContentUrlConfigValue()}/${contentPath}` : "";
};
var CONTENT_SERVER_QUERY_KEY = "CONTENT_SERVER_QUERY_KEY";
var emptyBlob = new Blob([]);
var emptyBlobURL = URL.createObjectURL(emptyBlob);
function useContentBlobUrl(contentId) {
  const { data: contentBlobURL } = useQuery(
    [CONTENT_SERVER_QUERY_KEY, contentId],
    () => __async(this, null, function* () {
      const response = yield leagueFetch(`content/${contentId}`, {
        method: "GET",
        api: "content"
      });
      const blob = yield response.blob();
      return URL.createObjectURL(blob);
    }),
    { enabled: Boolean(contentId) }
  );
  useEffect(
    () => (
      // clean up
      () => {
        if (contentBlobURL) {
          URL.revokeObjectURL(contentBlobURL);
        }
      }
    ),
    [contentBlobURL]
  );
  if (!contentId) {
    return void 0;
  }
  return contentBlobURL || emptyBlobURL;
}

// src/upload/upload-file.ts
var uploadFile = (file) => __async(void 0, null, function* () {
  if (!file)
    throw new Error("File is required");
  const formData = createFormData(file);
  const uploadRequest = Auth.initialized ? yield createAuth0Request(formData) : yield createLegacyRequest(formData);
  return fetchUpload(uploadRequest);
});
var createFormData = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("name", file.name);
  return formData;
};
var createLegacyRequest = (body) => __async(void 0, null, function* () {
  const sessionId = Cookies.get("SID2");
  if (!sessionId)
    throw new Error("Authentication required");
  let contentServerUrl = getContentUrlConfigValue();
  const url = `${contentServerUrl}/contentsave/${sessionId}`;
  return new Request(url, {
    method: "POST",
    body
  });
});
var createAuth0Request = (body) => __async(void 0, null, function* () {
  const accessToken = yield Auth.getToken();
  let contentServerUrl = getContentUrlConfigValue();
  const url = `${contentServerUrl}/content`;
  return new Request(url, {
    method: "POST",
    body,
    headers: new Headers({
      Authorization: `Bearer ${accessToken}`
    })
  });
});
var fetchUpload = (request) => __async(void 0, null, function* () {
  const response = yield fetch(request);
  if (!response.ok) {
    throw new Error(`fetchUpload error: ${response.status}`);
  }
  const data = yield response.json();
  return data;
});
export {
  getContentUrl,
  uploadFile,
  useContentBlobUrl
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/league-content-api'] = window.leagueSDKsPresent['@leagueplatform/league-content-api'] || [];
    window.leagueSDKsPresent['@leagueplatform/league-content-api'].push('2.28.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/league-content-api'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/league-content-api module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map